module.exports = __webpack_public_path__ + "img/box2.9631f62e.jpg";